// extracted by mini-css-extract-plugin
export default {"links":"tutorial_links__hYVE4","imageBox":"tutorial_imageBox__oocgr","image":"tutorial_image__yMCXH","list":"tutorial_list__OdRKS"};